import { TAction } from './types/action';

// Action Types
export const SET_ERROR = 'SET_ERROR';
export const SET_ERROR_VISIBLE = 'SET_ERROR_VISIBLE';

// Action Creators
export type TError = {
  type?: string;
  title: string;
  body?: string;
};

export type TErrorAction = TAction<TError>;
export type TSetErrorVisibleAction = TAction<boolean>;

export function createActionSetError(error: TError): TErrorAction {
  return {
    type: SET_ERROR,
    payload: error
  };
}

export function createActionSetErrorVisible(visible: boolean): TSetErrorVisibleAction {
  return {
    type: SET_ERROR_VISIBLE,
    payload: visible
  };
}
